const LAST_ACTIVITY_KEY = 'pams.lastActivityAt'

// 無操作タイムアウト（顧客指摘 2026/6/23 品川区: 30分→50分。全地域共通で OK）。
export const IDLE_MS = 50 * 60 * 1000

function hasWindow(): boolean {
  return typeof window !== 'undefined' && typeof window.localStorage !== 'undefined'
}

export function markActivity(): void {
  if (!hasWindow()) return
  window.localStorage.setItem(LAST_ACTIVITY_KEY, String(Date.now()))
}

export function clearActivity(): void {
  if (!hasWindow()) return
  window.localStorage.removeItem(LAST_ACTIVITY_KEY)
}

export function isIdleExpired(): boolean {
  if (!hasWindow()) return false
  const raw = window.localStorage.getItem(LAST_ACTIVITY_KEY)
  if (!raw) return false
  const last = parseInt(raw, 10)
  if (Number.isNaN(last)) return false
  return Date.now() - last >= IDLE_MS
}
